import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// ---Third-party imports
import React from 'react';
// ---Framework imports
import { each } from 'ldash';
import { Sel } from 'uix/registries';
import { useSelector, useFrontendConfig } from 'uix/hooks';
// ---Local imports
import { useIndexList, useOffsetNavigation } from 'uix/frontend/hooks';
import { FacetAlphaIndex, Facets } from './facets';
import { PageNavigator } from './pageNavigator';
import { Button, Dropdown } from './nativeComps';
import { Titles } from './titles';
let loadComps = (comp, cfg)=>{
    /* Loads frontend component by dcfg with necassary data */ let facetted = true;
    let { inHeaderNav, inPreHeaderNav, inBottomNav } = useFrontendConfig('navigation');
    let { offset, max, setMax, order, setOrder, sort, setSort, sortAvailable } = useOffsetNavigation();
    let { facets, navigator, titles, loading } = useIndexList({
        offset,
        max,
        facetted,
        order,
        sort
    });
    const sortOrderButton = /*#__PURE__*/ _jsx(Button, {
        content: "Asc",
        active: order == 'asc',
        onClick: ()=>setOrder(order == 'asc' ? 'desc' : 'asc')
    });
    let ce = (c, p)=>/*#__PURE__*/ React.createElement(c, p);
    let components = {
        // containers
        preHeaderNav: ce(PreHeaderNav, {
            cfg: inPreHeaderNav
        }),
        bottomNav: ce(BottomNav, {
            cfg: inBottomNav
        }),
        headerNav: ce(HeaderNav, {
            cfg: inHeaderNav
        }),
        // components
        sortOrderButton: sortOrderButton,
        countTitles: ce('h1', {
            children: `${navigator.total} Titel `
        }),
        filterAlpha: ce(FacetAlphaIndex, {
            className: 'filterAlpha',
            facets
        }),
        maxrowsSelect: ce(MaxRowsSelect, {
            setMax
        }),
        pagingControls: ce(PageNavigator, {
            pagination: false,
            className: 'pagingControls',
            indicator: true,
            max,
            ...navigator
        }),
        sortindexSelect: ce(SortIndexSelect, {
            options: sortAvailable,
            setSort
        }),
        mdList: ce(Titles, {
            titles
        }),
        listNavigation: ce(Facets, {
            facets,
            className: 'listNavigation'
        }),
        scrollTop: ce(ScrollTop, {
            divId: 'centerMiddle'
        })
    };
    let comps = [];
    if (comp && comp.length > 0) {
        if (cfg === 'parts') {
            comps = comp.map((r, i)=>components[r.type] ? [
                    {
                        ...components[r.type],
                        key: i
                    },
                    r
                ] : [
                    `Part ${r.type} not found`,
                    r
                ]);
        } else comps = comp.map((r, i)=>components[r] ? {
                ...components[r],
                key: i
            } : `Component ${r} not found`);
    }
    return comps || [];
};
const mapParts = (parts)=>{
    // parts is a list of [(React.Component, cfg), ..]
    if (parts.length == 0) {
        return null;
    }
    return parts.map(([part, cfg])=>part);
};
const alignParts = (parts)=>{
    /* create parts and group by align attribute*/ let aParts = {};
    if (parts.length === 0) {
        return [];
    } else {
        each([
            'top',
            'left',
            'center',
            'right',
            'bottom',
            'dialog'
        ], (align)=>{
            let filtered = parts.filter(([part, cfg])=>cfg.align == align || !cfg.align && align == 'center');
            aParts[align] = mapParts(filtered);
        });
        return aParts;
    }
};
export const useParts = (partCfg)=>{
    let parts = alignParts(loadComps(partCfg, 'parts'));
    return parts;
};
export const Layout = ({ layout, parts })=>{
    let { useLayout } = layout;
    if (parts && parts.length > 0) {
        parts = useParts(parts);
    } else {
        parts = {};
    }
    let { top, left, right, center, bottom } = parts;
    let cnt = (parts, cprops)=>{
        return /*#__PURE__*/ _jsx("div", {
            ...cprops,
            children: parts
        });
    };
    let flexLayout = /*#__PURE__*/ _jsxs("div", {
        id: "flexWrapper",
        className: "body",
        children: [
            cnt(top, {
                className: 'topPart'
            }),
            /*#__PURE__*/ _jsxs("div", {
                id: "center",
                className: "middlePart",
                children: [
                    cnt(left, {
                        id: 'centerLeft',
                        className: 'leftPart'
                    }),
                    cnt(center, {
                        id: 'centerMiddle',
                        className: 'centerPart'
                    }),
                    cnt(right, {
                        id: 'centerRight',
                        className: 'rightPart'
                    })
                ]
            }),
            cnt(bottom, {
                className: 'bottomPart'
            })
        ]
    });
    let layouts = {
        flexLayout: flexLayout
    }[useLayout];
    if (Object.keys(parts).length > 0) {
        return layouts || /*#__PURE__*/ _jsxs("div", {
            children: [
                'Layout "',
                useLayout,
                '" not found'
            ]
        });
    } else {
        return /*#__PURE__*/ _jsx("span", {
            children: "No Parts defined"
        });
    }
};
//containers
export const BottomNav = ({ cfg })=>{
    let comps = loadComps(cfg);
    return /*#__PURE__*/ _jsx("nav", {
        className: 'bottomNav',
        children: comps
    });
};
export const PreHeaderNav = ({ cfg })=>{
    let comps = loadComps(cfg);
    return /*#__PURE__*/ _jsx("nav", {
        className: 'preHeaderNav',
        children: comps
    });
};
export const HeaderNav = ({ cfg })=>{
    let comps = loadComps(cfg);
    return /*#__PURE__*/ _jsx("nav", {
        className: 'headerNav',
        children: comps
    });
};
export const NavMain = ({})=>{
    return /*#__PURE__*/ _jsx("nav", {
        style: {
            marginBottom: '1rem',
            padding: '0.5rem',
            borderBottom: '1px solid lightgrey'
        },
        className: 'navMain',
        children: /*#__PURE__*/ _jsx("h2", {
            children: "Space for MainHeader with Logo and Searchbar zB"
        })
    });
};
//components
export const SortIndexSelect = ({ options, setSort })=>{
    let i18n = useSelector(Sel.i18n);
    return /*#__PURE__*/ _jsx(Dropdown, {
        i18n: i18n,
        className: 'sortIndexSelect',
        options: options,
        onSetValue: setSort
    });
};
export const MaxRowsSelect = ({ setMax })=>{
    const amountShow = [
        {
            value: 10,
            text: '10 Treffer pro Seite'
        },
        {
            value: 20,
            text: '20 Treffer pro Seite'
        },
        {
            value: 30,
            text: '30 Treffer pro Seite'
        },
        {
            value: 50,
            text: '50 Treffer pro Seite'
        },
        {
            value: 100,
            text: '100 Treffer pro Seite'
        }
    ];
    return /*#__PURE__*/ _jsx(Dropdown, {
        className: 'maxRowSelect',
        options: amountShow,
        onSetValue: setMax
    });
};
export const ScrollTop = ({ divId })=>{
    const scrollTop = ()=>{
        if (!divId) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        } else {
            document.getElementById(divId).scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };
    return /*#__PURE__*/ _jsx(Button, {
        content: "Zurück nach oben",
        onClick: scrollTop
    });
};
